import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/index.css';
import './assets/styles/app.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// React.StrictMode is intentionally omitted: with react-snap pre-render +
// React 19, StrictMode's stricter hydration validation surfaces false-positive
// mismatches that the app would recover from anyway. Re-enable locally for
// development debugging when needed.
const AppWithProviders = () => (
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

const rootElement = document.getElementById('root') as HTMLElement;

if (rootElement.hasChildNodes()) {
  // onRecoverableError downgrades hydration mismatches to console warnings
  // instead of uncaught errors. React 19 recovers from these by re-rendering
  // the affected subtree on the client — the UI is correct, but the error
  // appears in the console as a hard "Uncaught Error: #418" without this hook.
  //
  // Mismatches we know about and accept:
  //   - react-helmet-async writing <head> tags asynchronously (no React 19 build yet)
  //   - browser lazy-load intervention swapping <img>.src to placeholders
  //   - <picture> currentSrc selection mutating attributes after react-snap snapshot
  ReactDOM.hydrateRoot(rootElement, <AppWithProviders />, {
    onRecoverableError: (error) => {
      const msg = error instanceof Error ? error.message : String(error);
      // Hydration mismatches are recoverable — log once at warn level, not error.
      if (msg.includes('Hydration') || msg.includes('hydrat') || msg.includes('#418') || msg.includes('#419') || msg.includes('#421') || msg.includes('#422') || msg.includes('#423') || msg.includes('#425')) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('[hydration] recoverable mismatch:', msg);
        }
        return;
      }
      console.error('[recoverable error]', error);
    },
  });
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<AppWithProviders />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
